// CardSection.js
import React from 'react';
import {CardElement} from 'react-stripe-elements';

class CardSection extends React.Component {
  constructor(){
    super();
    this.state = {
      content: "",
      error: {
        message: null,
        code: null,
        type: null
      },
      empty: true,
      value: null,
      complete: false,
      updated: false
    }
  }

  renderCard = () => (
    <CardElement 
        onChange={ ({complete, empty, error, value}) => {
            this.setState({
              complete, 
              empty, 
              error, 
              value,
              updated: false // Change has occurred can update again at componentDidUpdate
            });
        }}
        style={{ base: {fontSize: '18px'}}}
    />
  )

  componentDidUpdate() {
    if (!this.state.updated) {
      this.setState({
        ...this.state,
        updated: true // once update has completed dont update anymore until next change
      });
    }
  }

  render() {
    return this.props.render(this.state, this.renderCard);
  }
};

export default CardSection;


// WEBPACK FOOTER //
// ./src/js/components/Form/PaymentForms/CardSection.jsx